'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _flickity = require('flickity');

var _flickity2 = _interopRequireDefault(_flickity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    options: Object
  },

  mounted: function mounted() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {
    this.$flickity.destroy();
    this.$flickity = null;
  },


  methods: {
    /**
     * Initialize a new flickity and emit init event.
     */
    init: function init() {
      this.$flickity = new _flickity2.default(this.$refs.track, this.options);
      this.$emit('init', this.$flickity);
    },


    /**
     * Return the current flickity instance to access directly
     *
     * @returns {Flickity}
     */
    flickity: function flickity() {
      return this.$flickity;
    },


    /**
     * Selecting Slides
     */

    /**
     * Select a slide
     *
     * @param {number} index
     * @param {boolean} isWrapped
     * @param {boolean} isInstant
     */
    select: function select(index, isWrapped, isInstant) {
      this.$flickity.select(index, isWrapped, isInstant);
    },


    /**
     * Change to the next slide
     *
     * @param {boolean} isWrapped
     * @param {boolean} isInstant
     */
    next: function next(isWrapped, isInstant) {
      this.$flickity.next(isWrapped, isInstant);
    },


    /**
     * Change to the previous slide
     *
     * @param {boolean} isWrapped
     * @param {boolean} isInstant
     */
    previous: function previous(isWrapped, isInstant) {
      this.$flickity.previous(isWrapped, isInstant);
    },


    /**
     * Select a cell
     *
     * @param {number} value
     * @param {boolean} isWrapped
     * @param {boolean} isInstant
     */
    selectCell: function selectCell(value, isWrapped, isInstant) {
      this.$flickity.selectCell(value, isWrapped, isInstant);
    },


    /**
     * Sizing and Positioning
     */

    /**
     * Trigger a resize event
     */
    resize: function resize() {
      this.$flickity.resize();
    },


    /**
     * Trigger a reposition event
     */
    reposition: function reposition() {
      this.$flickity.reposition();
    },


    /**
     * Adding and removing cells
     */

    /**
     * Prepend elements to flickity
     *
     * @param {array|HTMLElement|NodeList} elements
     */
    prepend: function prepend(elements) {
      this.$flickity.prepend(elements);
    },


    /**
     * Append elements to flickity
     *
     * @param {array|HTMLElement|NodeList} elements
     */
    append: function append(elements) {
      this.$flickity.append(elements);
    },


    /**
     * Insert elements at a given index
     *
     * @param {array|HTMLElement|NodeList} elements
     * @param {number} index
     */
    insert: function insert(elements, index) {
      this.$flickity.insert(elements, index);
    },


    /**
     * Remove elements from flickity
     *
     * @param {array|HTMLElement|NodeList} elements
     */
    remove: function remove(elements) {
      this.$flickity.remove(elements);
    },


    /**
     * Player
     */

    /**
     * Trigger a playPlayer event
     */
    playPlayer: function playPlayer() {
      this.$flickity.playPlayer();
    },


    /**
     * Trigger a stopPlayer event
     */
    stopPlayer: function stopPlayer() {
      this.$flickity.stopPlayer();
    },


    /**
     * Trigger a pausePlayer event
     */
    pausePlayer: function pausePlayer() {
      this.$flickity.pausePlayer();
    },


    /**
     * Trigger a unpausePlayer event
     */
    unpausePlayer: function unpausePlayer() {
      this.$flickity.unpausePlayer();
    },


    /**
     * Trigger a rerender event
     */
    rerender: function rerender() {
      this.$flickity.destroy();
      this.init();
    },


    /**
     * Utilities
     */

    /**
     * Destroy the flickity instance
     */
    destroy: function destroy() {
      this.$flickity.destroy();
    },


    /**
     * Trigger a rerender event
     */
    reloadCells: function reloadCells() {
      this.$flickity.reloadCells();
    },


    /**
     * Get the cell elements
     *
     * @returns {array}
     */
    getCellElements: function getCellElements() {
      return this.$flickity.getCellElements();
    },


    /**
     * Return flickity data
     *
     * @returns {Flickity}
     */
    data: function data() {
      return _flickity2.default.data(this.$refs.track);
    },


    /**
     * Events
     */

    /**
     * Attach an event
     *
     * @param {string} eventName
     * @param {function} listener
     */
    on: function on(eventName, listener) {
      this.$flickity.on(eventName, listener);
    },

    /**
     * Remove an event
     *
     * @param {string} eventName
     * @param {function} listener
     */
    off: function off(eventName, listener) {
      this.$flickity.off(eventName, listener);
    },


    /**
     * Attach an event once
     *
     * @param {string} eventName
     * @param {function} listener
     */
    once: function once(eventName, listener) {
      this.$flickity.once(eventName, listener);
    },


    /**
     * Properties
     */
    /**
     * Return the selected element
     *
     * @returns {HTMLElement}
     */
    selectedElement: function selectedElement() {
      return this.$flickity.selectedElement;
    },


    /**
     * Return the selected elements
     *
     * @returns {array}
     */
    selectedElements: function selectedElements() {
      return this.$flickity.selectedElements;
    },


    /**
     * Return the selected index
     *
     * @returns {number}
     */
    selectedIndex: function selectedIndex() {
      return this.$flickity.selectedIndex;
    },


    /**
     * Return the cells
     *
     * @returns {array}
     */
    cells: function cells() {
      return this.$flickity.cells;
    },


    /**
     * Return the slides
     *
     * @returns {array}
     */
    slides: function slides() {
      return this.$flickity.slides;
    },


    /**
     * Disable dragging of slider
     */
    disableDrag: function disableDrag() {
      this.$flickity.options.draggable = false;
      this.$flickity.updateDraggable();
    },


    /**
     * Enable dragging of slider
     */
    enableDrag: function enableDrag() {
      this.$flickity.options.draggable = true;
      this.$flickity.updateDraggable();
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//